module.exports = __webpack_public_path__ + "static/media/9.e6b2311e.PNG";